import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, IndexRoute, browserHistory} from 'react-router';

import {createStore} from 'redux';
import {Provider} from 'react-redux';

import {isLoggedIn} from './utils/auth';
import configureStore from './utils/configureStore';

import {AppContainer} from './components/common/App';
import {AppHeaderWrapperContainer} from './components/common/AppHeaderWrapper';

import {HomeContainer} from './components/views/home/Home';
import {StoreContainer} from './components/views/store/Store';
import {WatchContainer} from './components/views/store/Watch';
import Locations from './components/views/locations/Locations';
import AboutUs from './components/views/aboutus/AboutUs';
import {FaqContainer} from './components/views/faq/Faq';
import {FoundationContainer} from './components/views/foundation/Foundation';
import {ScheduleAppointmentContainer} from './components/views/scheduleappointment/ScheduleAppointment';
import Designers from './components/views/designers/Designers';
import SingleDesigner from './components/views/designers/SingleDesigner';
import {CustomDesignContainer} from './components/views/customdesign/CustomDesign';
import Careers from './components/views/careers/Careers';
import Heroes from './components/views/heroes/Heroes';
import Heritage from './components/views/heritage/Heritage';
import Privacy from './components/views/legal/Privacy';
import Terms from './components/views/legal/Terms';
import Warranties from './components/views/warranties/Warranties';
import AsSeen from './components/views/asseen/AsSeen';


import {ContactPageContainer} from './components/views/contact/ContactPage';
import {PressContainer} from './components/views/contact/Press';
import ThankYou from './components/views/contact/ThankYou';
import VideoChat from './components/views/contact/VideoChat';
import Covid19 from './components/views/promopages/covid19/Covid19';
import NoKidHungry from './components/views/promopages/nokidhungry/NoKidHungry';
import NolaFlood2021 from './components/views/promopages/nolaflood2021/NolaFlood2021';


// Diamonds Direct 2.0 Specfic Imports
import {GalleryContainer} from './components/views/gallery/Gallery';
import {ProductPageContainer} from './components/views/product-page/ProductPage';
import {AccountContainer} from './components/views/account/Account';
import Finance from './components/views/finance/Finance';

// Splash pages
import EngagementSplash from './components/views/gallery/blocks/splash/EngagementSplash';
import MensBandsSplash from './components/views/gallery/blocks/splash/MensBandsSplash';
import WomensBandsSplash from './components/views/gallery/blocks/splash/WomensBandsSplash';
import BraceletSplash from './components/views/gallery/blocks/splash/BraceletSplash';
import EarringSplash from './components/views/gallery/blocks/splash/EarringSplash';
import NecklaceSplash from './components/views/gallery/blocks/splash/NecklaceSplash';
import RingSplash from './components/views/gallery/blocks/splash/RingSplash';

// Eduction pages
import EducationDiamond from './components/views/education/EducationDiamond';
import EducationGem from './components/views/education/EducationGem';
import EducationMetal from './components/views/education/EducationMetal';
import EducationStyle from './components/views/education/EducationStyle';
import EducationConflict from './components/views/education/EducationConflict';
import {EducationLabGrownContainer} from './components/views/education/EducationLabGrown';

// Influencer pages
import Influencers from './components/views/influencers/Influencers';
import {InfluenceBrightonbutlerContainer} from './components/views/influencers/pages/InfluenceBrightonbutler';
import {InfluenceCourtnwilliamsContainer} from './components/views/influencers/pages/InfluenceCourtnwilliams';
import {InfluenceAubreyalleyContainer} from './components/views/influencers/pages/InfluenceAubreyalley';
import {InfluenceHauteofftherackContainer} from './components/views/influencers/pages/InfluenceHauteofftherack';
import {InfluenceMeganrunionmcrContainer} from './components/views/influencers/pages/InfluenceMeganrunionmcr';

// Diamond Jewelry pages
import {DiamondStudsContainer} from './components/views/diamondpages/DiamondStuds';
import {DiamondPendantsContainer} from './components/views/diamondpages/DiamondPendants';
import {DiamondBraceletsContainer} from './components/views/diamondpages/DiamondBracelets';
import {DiamondNecklacesContainer} from './components/views/diamondpages/DiamondNecklaces';

// Search Page
import {SearchResultsContainer} from './components/views/search/SearchResults';

// Promo Page Imports
import Summer2018 from './components/views/promopages/summer2018/Summer2018';
import Fall2018 from './components/views/promopages/fall2018/Fall2018';
import Holiday2018 from './components/views/promopages/holiday2018/Holiday2018';
import December2018 from './components/views/promopages/december2018/December2018';
import Valentines2019 from './components/views/promopages/valentines2019/Valentines2019';
import Spring2019 from './components/views/promopages/spring2019/Spring2019';
import {Mothers2021Container} from './components/views/promopages/mothers2021/Mothers2021';
import {Mothers2022Container} from './components/views/promopages/mothers2022/Mothers2022';
import Summer2019 from './components/views/promopages/summer2019/Summer2019';
import Fall2019 from './components/views/promopages/fall2019/Fall2019';
import Holiday2019 from './components/views/promopages/holiday2019/Holiday2019';
import December2019 from './components/views/promopages/december2019/December2019';
import {Valentines2021Container} from './components/views/promopages/valentines2021/Valentines2021';
import {Valentines2022Container} from './components/views/promopages/valentines2022/Valentines2022';
import {Spring2021Container} from './components/views/promopages/spring2021/Spring2021';
import {Summer2021Container} from './components/views/promopages/summer2021/Summer2021';
import {Sept2021Container} from './components/views/promopages/sept2021/Sept2021';
import {SingleDesigner2021Container} from './components/views/promopages/singledesigner2021/SingleDesigner2021';
import {Holiday2021Container} from './components/views/promopages/holiday2021/Holiday2021';
import {BlackFriday2021Container} from './components/views/promopages/blackfriday2021/BlackFriday2021';
import {December2021Container} from './components/views/promopages/december2021/December2021';
import {Earring2021Container} from './components/views/promopages/earring2021/Earring2021';
import {Spring2022Container} from './components/views/promopages/spring2022/Spring2022';
import {June2022Container} from './components/views/promopages/june2022/June2022';
import {Summer2022Container} from './components/views/promopages/summer2022/Summer2022';
import {Sept2022Container} from './components/views/promopages/sept2022/Sept2022';
import {SingleDesigner2022Container} from './components/views/promopages/singledesigner2022/SingleDesigner2022';
import {Auburn2022Container} from './components/views/promopages/auburn2022/Auburn2022';
import {Holiday2022Container} from './components/views/promopages/holiday2022/Holiday2022';
import {Earring2022Container} from './components/views/promopages/earring2022/Earring2022';


// Async components
// const HomeContainer1 = React.lazy(() => import('./components/views/home/Home.jsx'));

const store = configureStore();

require('./styles/main.scss');

function requireAuth(nextState, replaceState, cb) {
  if(!isLoggedIn()) {
    replaceState({ pathname: '/' });
  }
  cb();
}

function requireNoAuth(nextState, replaceState, cb) {
    if(isLoggedIn()) {
    replaceState({ pathname: '/' });
    }
    cb();
}

ReactDOM.render(
	<Provider store={store}>
	  <Router onUpdate={() => window.scroll(0, 0)} history={browserHistory}>
	    <Route path='/' component={AppContainer}>
	    	


            <Route component={AppHeaderWrapperContainer}>
    			<IndexRoute component={HomeContainer} />
                <Route path='index.html' component={HomeContainer} />

    			<Route path='austin' component={StoreContainer} store_id='atx' />
    			<Route path='baybrook' component={StoreContainer} store_id='bay' />
                <Route path='birmingham' component={StoreContainer} store_id='bhm' />
                <Route path='boca-raton' component={StoreContainer} store_id='boc' />
    			<Route path='charleston' component={StoreContainer} store_id='chs' />
    			<Route path='charlotte' component={StoreContainer} store_id='clt' />
                <Route path='cleveland' component={StoreContainer} store_id='cle' />
    			<Route path='columbus' component={StoreContainer} store_id='coh' />
    			<Route path='dallas' component={StoreContainer} store_id='dfw' />
    			<Route path='ecj-watch-boutique' component={WatchContainer} store_id='ecj' />
                <Route path='frisco' component={StoreContainer} store_id='ftx' />
                <Route path='greenville' component={StoreContainer} store_id='gsc' />
                <Route path='houston' component={StoreContainer} store_id='hou' />
    			<Route path='indianapolis' component={StoreContainer} store_id='ind' />
                <Route path='jacksonville' component={StoreContainer} store_id='jax' />
                <Route path='kansas-city' component={StoreContainer} store_id='kcy' />
    			<Route path='new-orleans' component={StoreContainer} store_id='nol' />
                <Route path='pittsburgh' component={StoreContainer} store_id='pit' />
                <Route path='oklahoma-city' component={StoreContainer} store_id='okc' />
    			<Route path='raleigh' component={StoreContainer} store_id='ral' />
    			<Route path='richmond' component={StoreContainer} store_id='rva' />
    			<Route path='st-louis' component={StoreContainer} store_id='stl' />
    			<Route path='san-antonio' component={StoreContainer} store_id='san' />
    			<Route path='sanantonio' component={StoreContainer} store_id='san' />
                <Route path='troy' component={StoreContainer} store_id='try' />
                <Route path='tysons' component={StoreContainer} store_id='nva' />
    			<Route path='virginia-beach' component={StoreContainer} store_id='vab' />

    			<Route path='locations' component={Locations} />

                <Route path='about-us' component={AboutUs} />
                <Route path='faq' component={FaqContainer} />
                <Route path='frequently-asked-questions' component={FaqContainer} />
                <Route path='our-foundation' component={FoundationContainer} />
                <Route path='careers' component={Careers} />
                <Route path='heroes' component={Heroes} />
                <Route path='heroes-in-uniform' component={Heroes} />
                <Route path='account' component={AccountContainer} onEnter={requireAuth} />
                <Route path='as-seen-in' component={AsSeen} />

                <Route path='our-guarantees' component={Warranties} />
                <Route path='our-heritage' component={Heritage} />
                <Route path='heritage-of-60years' component={Heritage} />

                <Route path='custom-design' component={CustomDesignContainer} />
                <Route path='custom-design/' component={CustomDesignContainer} />

                <Route path='schedule' component={ScheduleAppointmentContainer} />
                <Route path='appointments' component={ScheduleAppointmentContainer} />

                <Route path='diamonds-direct-search' component={SearchResultsContainer} />                

                <Route path='privacy-policy' component={Privacy} />
                <Route path='terms-of-use' component={Terms} />

                <Route path='contact-us' component={ContactPageContainer} />
                <Route path='virtual' component={ContactPageContainer} />
                <Route path='press' component={PressContainer} />
                <Route path='thank-you' component={ThankYou} />
                <Route path='video-chat' component={VideoChat} />

                <Route path='financing' component={Holiday2022Container} />
                <Route path='financing-placeholder' component={Finance} />

                <Route path='holiday' component={Earring2022Container} />
                <Route path='valentinesday' component={Valentines2022Container} />_
                <Route path='spring' component={Spring2022Container} />
                <Route path='pod' component={Spring2021Container} />
                <Route path='mothersday' component={Mothers2022Container} />
                <Route path='mothers-day' component={Mothers2022Container} />
                <Route path='june-financing' component={Mothers2021Container} />
                <Route path='summer' component={Summer2022Container} />
                <Route path='5yearfinancing' component={Sept2022Container} />
                <Route path='3yearfinancing' component={Holiday2022Container} />
                <Route path='covid-19-updates' component={Covid19} />
                <Route path='no-kid-hungry' component={NoKidHungry} />
                <Route path='hurricane-relief' component={NolaFlood2021} />
                <Route path='new-orleans-financing' component={Sept2021Container} />
                <Route path='single-designer' component={SingleDesigner2021Container} />
                <Route path='designer-spotlight' component={SingleDesigner2022Container} />
                <Route path='black-friday' component={BlackFriday2021Container} />
                <Route path='december-financing' component={December2021Container} />
                <Route path='4yearfinancing' component={December2021Container} />
                <Route path='auburngiveaway' component={Auburn2022Container} />

                <Route path='designers' component={Designers} />
                <Route path='designers-links' component={Designers} />

                <Route path='diamond-studs' component={DiamondStudsContainer} />
                <Route path='diamond-pendants' component={DiamondPendantsContainer} />
                <Route path='diamond-bracelets' component={DiamondBraceletsContainer} />
                <Route path='diamond-necklaces' component={DiamondNecklacesContainer} />

                <Route path='engagement-rings' component={EngagementSplash} />
                <Route path='mens-bands' component={MensBandsSplash} />
                <Route path='womens-bands' component={WomensBandsSplash} />

                <Route path='fashion-bracelets' component={BraceletSplash} />
                <Route path='fashion-earrings' component={EarringSplash} />
                <Route path='fashion-necklaces' component={NecklaceSplash} />
                <Route path='fashion-rings' component={RingSplash} />

                <Route path='gallery'>
                    <Route path='engagement-rings' component={GalleryContainer} productMode='engagement' />
                    <Route path='wedding-bands/mens' component={GalleryContainer} productMode='mensbands' />
                    <Route path='wedding-bands/womens' component={GalleryContainer} productMode='womensbands' />
                    <Route path='fine-jewelry' component={GalleryContainer} productMode='fashion' />
                    <Route path='mens-jewelry' component={GalleryContainer} productMode='mens' />
                </Route>

                <Route path='education'>
                    <Route path='diamonds' component={EducationDiamond} />
                    <Route path='gems-and-pearls' component={EducationGem} />
                    <Route path='metals' component={EducationMetal} />
                    <Route path='styles' component={EducationStyle} />
                    <Route path='conflict-free' component={EducationConflict} />
                    <Route path='lab-grown' component={EducationLabGrownContainer} />
                </Route>

                <Route path='jewelry-box'>
                    <IndexRoute component={Influencers} />
                    <Route path='brightonbutler' component={InfluenceBrightonbutlerContainer} />
                    <Route path='courtnwilliams' component={InfluenceCourtnwilliamsContainer} />
                    <Route path='meganrunionmcr' component={InfluenceMeganrunionmcrContainer} />
                    <Route path='hauteofftherack' component={InfluenceHauteofftherackContainer} />
                    <Route path='aubreyalley' component={InfluenceAubreyalleyContainer} />
                </Route>

                <Route path='setting/:lookupKey' component={ProductPageContainer} product_type='setting' />
                <Route path='jewelry/:lookupKey' component={ProductPageContainer} product_type='jewelry' />
                <Route path='diamond/:lookupKey' component={ProductPageContainer} product_type='diamond' />
                <Route path='band/:lookupKey' component={ProductPageContainer} product_type='jewelry' />

                <Route path='designer'>
                    <Route path='a-jaffe' component={SingleDesigner} designer_code='ajaffe' />
                    <Route path='artcarved' component={SingleDesigner} designer_code='artcarved' />
                    <Route path='c-gonshor' component={SingleDesigner} designer_code='cgonshor' />
                    <Route path='christian-bauer' component={SingleDesigner} designer_code='christianbauer' />
                    <Route path='christopher-designs' component={SingleDesigner} designer_code='christopherdesigns' />
                    <Route path='coast-diamond' component={SingleDesigner} designer_code='coast' />
                    <Route path='fana' component={SingleDesigner} designer_code='fana' />
                    <Route path='furrer-jacot' component={SingleDesigner} designer_code='furrerjacot' />
                    <Route path='gottlieb' component={SingleDesigner} designer_code='gottlieb' />
                    <Route path='henri-daussi' component={SingleDesigner} designer_code='henridaussi' />
                    <Route path='jack-kelege' component={SingleDesigner} designer_code='jackkelege' />
                    <Route path='jeff-cooper' component={SingleDesigner} designer_code='jeffcooper' />
                    <Route path='kirk-kara' component={SingleDesigner} designer_code='kirkkara' />
                    <Route path='mastoloni' component={SingleDesigner} designer_code='mastoloni' />
                    <Route path='michael-m' component={SingleDesigner} designer_code='michaelm' />
                    <Route path='novell' component={SingleDesigner} designer_code='novell' />
                    <Route path='pejay' component={SingleDesigner} designer_code='pejay' />
                    <Route path='ses' component={SingleDesigner} designer_code='ses' />
                    <Route path='simon-g-jewelry' component={SingleDesigner} designer_code='simong' />
                    <Route path='sylvie-collection' component={SingleDesigner} designer_code='sylvie' />
                    <Route path='tacori' component={SingleDesigner} designer_code='tacori' />
                    <Route path='true-romance' component={SingleDesigner} designer_code='trueromance' />
                    <Route path='verragio' component={SingleDesigner} designer_code='verragio' />
                    <Route path='amden' component={SingleDesigner} designer_code='amden' />
                    <Route path='uneek' component={SingleDesigner} designer_code='uneek' />
                    <Route path='odelia' component={SingleDesigner} designer_code='odelia' />
                    <Route path='gabriel' component={SingleDesigner} designer_code='gabriel' />
                    <Route path='classique' component={SingleDesigner} designer_code='classique' />
                    <Route path='per-amore' component={SingleDesigner} designer_code='peramore' />
                    <Route path='benchmark' component={SingleDesigner} designer_code='benchmark' />
                    <Route path='diamonds-direct-designs' component={SingleDesigner} designer_code='dddesigns' />
                </Route>

    		</Route>
	    </Route>
	  </Router>
  </Provider>,
  document.getElementById('diamonds-direct')
);


// WEBPACK FOOTER //
// ./src/index.jsx